export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11382.f1479405.jpg";